import React, { useEffect, useState, useRef, Fragment } from "react";
import { PageHeader } from "../../../../Common";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import services from "../services";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import Joi from "@hapi/joi";
import { DeductionBreakdownReportSchemaObject } from "../DeductionBreakdownReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import xlsx from "json-as-xlsx";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import MessageModal from '../../../../UI/Modal/MessageModal';

const screenCode = "DEDUCTIONBREAKDOWNREPORT";

export function DeductionBreakdownListing(props) {

    const componentRef = useRef();
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]);
    const [divisions, setDivisions] = useState([]);
    const [reportSearchDetails, setReportSearchDetails] = useState(null);

    const [searchDetails, setSearchDetails] = useState({
        groupID: "0",
        estateID: "0",
        divisionID: "0",
        pluckingType: "0",
        fromDate: new Date().toISOString().split('T')[0],
        toDate: new Date().toISOString().split('T')[0]
    });

    const [reportRows, setReportRows] = useState([]);
    const [deductionTypes, setDeductionTypes] = useState([]);
    const [factoryDeductionTypes, setFactoryDeductionTypes] = useState([]);
    const [excelRows, setExcelRows] = useState([]);
    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        description: ""
    });

    useEffect(() => {
        trackPromise(getPermissions(), getGroupsForDropdown());
    }, []);

    useEffect(() => {
        trackPromise(getEstatesForDropdown());
    }, [searchDetails.groupID]);

    useEffect(() => {
        trackPromise(getDivisionsForDropDown());
    }, [searchDetails.estateID]);

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, DeductionBreakdownReportSchemaObject);
        errorMessage ? (error[target.name] = errorMessage) : delete error[target.name];
        setErrors(error);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    async function getPermissions() {
        const permissions = await authService.getPermissionsByScreen(screenCode);
        const isAuthorized = permissions.find((p) => p.permissionCode === "VIEWDEDUCTIONBREAKDOWNREPORT");
        if (isAuthorized === undefined) {
            props.history.push("/unauthorized");
            return;
        }
        const isGroupFilterEnabled = permissions.find((p) => p.permissionCode === "GROUPDROPDOWN");
        const isOperationEntityFilterEnabled = permissions.find((p) => p.permissionCode === "OPERATIONENTITYDROPDOWN");

        setPermissions({
            isAddEditEnabled: false,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        const token = tokenService.getUserDetailsFromTokenV2();
        setSearchDetails({
            ...searchDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID,
        });
        getGroupsForDropdown();
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(searchDetails.groupID);
        const token = tokenService.getUserDetailsFromTokenV2();
        const validEstateIds = token.operationEntities.map(entity => String(entity.OperationEntityID));

        const estateList = data
            .map((name, index) => name ? { id: String(index), name } : null)
            .filter(item => item !== null);

        const filteredEstates = estateList.filter(estate =>
            validEstateIds.includes(String(estate.id)) &&
            !estate.name.toUpperCase().includes("FACTORY")
        );

        const filteredEstateArray = [];
        filteredEstates.forEach(estate => {
            filteredEstateArray[parseInt(estate.id)] = estate.name;
        });

        setMultipleEstates(filteredEstateArray);
        setEstates(filteredEstateArray);
    }

    async function getDivisionsForDropDown() {
        const result = await services.getDivisionByEstateID(searchDetails.estateID);
        setDivisions(result);
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;

        validateInputs(target);

        if (target.name === "groupID") {
            setSearchDetails({
                ...searchDetails,
                [e.target.name]: value,
                estateID: "0",
                divisionID: "0",
                pluckingType: "0",
                fromDate: new Date().toISOString().split('T')[0],
                toDate: new Date().toISOString().split('T')[0]
            });
        } else if (target.name === "estateID") {
            setSearchDetails({
                ...searchDetails,
                [e.target.name]: value,
                divisionID: "0",
                pluckingType: "0",
                fromDate: new Date().toISOString().split('T')[0],
                toDate: new Date().toISOString().split('T')[0]
            });
        } else if (target.name === "divisionID") {
            setSearchDetails({
                ...searchDetails,
                [e.target.name]: value,
                pluckingType: "0",
                fromDate: new Date().toISOString().split('T')[0],
                toDate: new Date().toISOString().split('T')[0]
            });
        } else if (target.name === "pluckingType") {
            setSearchDetails({
                ...searchDetails,
                [e.target.name]: value,
                fromDate: new Date().toISOString().split('T')[0],
                toDate: new Date().toISOString().split('T')[0]
            });
        } else if (target.name === "fromDate") {
            setSearchDetails(prev => ({
                ...prev,
                fromDate: value,
                toDate: new Date().toISOString().split('T')[0]
            }));
        } else {
            setSearchDetails({
                ...searchDetails,
                [e.target.name]: value
            });
        }

        setReportRows([]);
        setReportSearchDetails(null);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    function mergeData(originals, deductions) {
        const deductionMap = {};

        deductions.forEach(deduction => {
            const key = deduction.pluckingCollectionID;
            if (!deductionMap[key]) {
                deductionMap[key] = { pluckingOriginal: deduction.pluckingOriginal, deductions: {} };
            }
            deductionMap[key].deductions[deduction.deductionTypeName] = deduction.deductionAmount;
        });

        return originals.map(original => {
            const key = original.pluckingCollectionID;
            return {
                ...original,
                pluckingOriginal: deductionMap[key]?.pluckingOriginal || 0,
                rounded: Math.round(original.totalAmount ?? 0),   // CHANGED — was original.netAmount
                deductions: deductionMap[key]?.deductions || {}
            };
        });
    }

    function mergeFactoryData(factoryNetResult, factoryOriginalResult, factoryDeductionResult) {

        const originalMap = {};
        const deductionMap = {};

        const dateKeyOf = (d) => new Date(d).toDateString();

        factoryOriginalResult.forEach(original => {
            const key = `${original.collectionPointID}_${original.fieldID}_${dateKeyOf(original.transactionDate)}`;
            originalMap[key] = original;
        });

        factoryDeductionResult.forEach(deduction => {
            const key = `${deduction.collectionPointID}_${deduction.fieldID}_${dateKeyOf(deduction.transactionDate)}`;
            if (!deductionMap[key]) deductionMap[key] = {};
            deductionMap[key][deduction.deductionTypeName] = deduction.deductionAmount;
        });

        return factoryNetResult.map(net => {
            const key = `${net.collectionPointID}_${net.fieldID}_${dateKeyOf(net.transactionDate)}`;
            return {
                ...net,
                factoryOriginal: originalMap[key]?.factoryOriginal ?? 0,
                rounded: Math.floor(net.factoryNet ?? 0),
                deductions: deductionMap[key] ?? {}
            };
        });
    }

    function buildFieldGroups(pluckerRows, factoryRows) {

        const divisionMap = {};

        pluckerRows.forEach(pluckerRow => {
            const divisionKey = pluckerRow.collectionPointID;

            if (!divisionMap[divisionKey]) {
                divisionMap[divisionKey] = {
                    collectionPointID: pluckerRow.collectionPointID,
                    collectionPointName: pluckerRow.collectionPointName,
                    fieldGroups: {}
                };
            }

            const fieldKey = pluckerRow.fieldID;
            if (!divisionMap[divisionKey].fieldGroups[fieldKey]) {
                divisionMap[divisionKey].fieldGroups[fieldKey] = {
                    fieldID: pluckerRow.fieldID,
                    fieldName: pluckerRow.fieldName,
                    pluckerRows: [],
                    factorySummariesByDate: {}
                };
            }

            divisionMap[divisionKey].fieldGroups[fieldKey].pluckerRows.push(pluckerRow);
        });

        factoryRows.forEach(factoryRow => {
            const divisionKey = factoryRow.collectionPointID;

            if (!divisionMap[divisionKey]) {
                divisionMap[divisionKey] = {
                    collectionPointID: factoryRow.collectionPointID,
                    collectionPointName: factoryRow.collectionPointName,
                    fieldGroups: {}
                };
            }

            const fieldKey = factoryRow.fieldID;
            if (!divisionMap[divisionKey].fieldGroups[fieldKey]) {
                divisionMap[divisionKey].fieldGroups[fieldKey] = {
                    fieldID: factoryRow.fieldID,
                    fieldName: factoryRow.fieldName,
                    pluckerRows: [],
                    factorySummariesByDate: {}
                };
            }

            const dateKey = new Date(factoryRow.transactionDate).toDateString();
            divisionMap[divisionKey].fieldGroups[fieldKey].factorySummariesByDate[dateKey] = factoryRow;
        });
        return Object.values(divisionMap).map(division => ({
            ...division,
            fieldGroups: Object.values(division.fieldGroups)
        }));
    }

    function flattenFieldGroups(divisionGroups) {

        const flattenedRows = [];
        const dateKeyOf = (d) => new Date(d).toDateString();

        divisionGroups.forEach(division => {
            division.fieldGroups.forEach(fieldGroup => {

                const pluckerRows = fieldGroup.pluckerRows;
                const factorySummariesByDate = fieldGroup.factorySummariesByDate || {};

                if (pluckerRows.length > 0) {
                    let i = 0;
                    while (i < pluckerRows.length) {
                        const currentDateKey = dateKeyOf(pluckerRows[i].collectionDate);
                        let j = i;
                        while (j < pluckerRows.length && dateKeyOf(pluckerRows[j].collectionDate) === currentDateKey) {
                            j++;
                        }
                        const dateGroupSize = j - i;
                        const factoryRowForDate = factorySummariesByDate[currentDateKey] || {};

                        for (let k = i; k < j; k++) {
                            flattenedRows.push({
                                rowType: "DATA",
                                division,
                                fieldGroup,
                                pluckerRow: pluckerRows[k],
                                factoryRow: k === i ? factoryRowForDate : null,
                                isFirstDateRow: k === i,
                                dateRowSpan: k === i ? dateGroupSize : 0
                            });
                        }
                        i = j;
                    }
                } else {
                    const dateEntries = Object.values(factorySummariesByDate);
                    if (dateEntries.length > 0) {
                        dateEntries.forEach(factoryRowForDate => {
                            flattenedRows.push({
                                rowType: "DATA",
                                division,
                                fieldGroup,
                                pluckerRow: null,
                                factoryRow: factoryRowForDate,
                                isFirstDateRow: true,
                                dateRowSpan: 1
                            });
                        });
                    } else {
                        flattenedRows.push({
                            rowType: "DATA",
                            division,
                            fieldGroup,
                            pluckerRow: null,
                            factoryRow: {},
                            isFirstDateRow: true,
                            dateRowSpan: 1
                        });
                    }
                }
            });
        });

        return flattenedRows;
    }

    function sortRows(rows) {
        return [...rows].sort((a, b) => {
            if (a.collectionPointID !== b.collectionPointID) return a.collectionPointID - b.collectionPointID;
            if (a.fieldID !== b.fieldID) return a.fieldID - b.fieldID;
            const dateA = new Date(a.collectionDate);
            const dateB = new Date(b.collectionDate);
            if (dateA.getTime() !== dateB.getTime()) return dateA - dateB;   // always ascending now
            return a.employeeID - b.employeeID;
        });
    }

    function calculateDivisionRowSpan(rows) {
        const result = [...rows];
        let i = 0;
        while (i < result.length) {
            if (result[i].rowType !== "DATA") { i++; continue; }
            const currentDivision = result[i].division.collectionPointID;
            let rowSpan = 1;
            let j = i + 1;
            while (j < result.length && result[j].rowType === "DATA" && result[j].division.collectionPointID === currentDivision) {
                rowSpan++; j++;
            }
            result[i].isFirstDivisionRow = true;
            result[i].divisionRowSpan = rowSpan;
            for (let k = i + 1; k < j; k++) {
                result[k].isFirstDivisionRow = false;
                result[k].divisionRowSpan = 0;
            }
            i = j;
        }
        return result;
    }

    function calculateFieldRowSpan(rows) {
        const result = [...rows];
        let i = 0;
        while (i < result.length) {
            if (result[i].rowType !== "DATA") { i++; continue; }
            const currentDivision = result[i].division.collectionPointID;
            const currentField = result[i].fieldGroup.fieldID;
            let rowSpan = 1;
            let j = i + 1;
            while (
                j < result.length &&
                result[j].rowType === "DATA" &&
                result[j].division.collectionPointID === currentDivision &&
                result[j].fieldGroup.fieldID === currentField
            ) {
                rowSpan++; j++;
            }
            result[i].isFirstFieldRow = true;
            result[i].fieldRowSpan = rowSpan;
            for (let k = i + 1; k < j; k++) {
                result[k].isFirstFieldRow = false;
                result[k].fieldRowSpan = 0;
            }
            i = j;
        }
        return result;
    }

    function extractDeductionTypes(deductions) {
        const deductionTypeSet = new Set();
        deductions.forEach(deduction => deductionTypeSet.add(deduction.deductionTypeName));
        return [...deductionTypeSet];
    }

    function populateDeductionColumns(rows, types) {
        return rows.map(row => {
            const deductions = {};
            types.forEach(type => { deductions[type] = row.deductions[type] ?? 0; });
            return { ...row, deductions };
        });
    }

    function appendTotals(rows, deductionTypes, factoryDeductionTypes) {

        const result = [];

        let grandPluckerOriginal = 0, grandPluckerNet = 0, grandPluckerRounded = 0;
        let grandFactoryOriginal = 0, grandFactoryNet = 0, grandFactoryRounded = 0;

        const grandDeductions = {};
        const grandFactoryDeductions = {};
        deductionTypes.forEach(type => { grandDeductions[type] = 0; });
        factoryDeductionTypes.forEach(type => { grandFactoryDeductions[type] = 0; });

        let i = 0;
        while (i < rows.length) {

            let divisionPluckerOriginal = 0, divisionPluckerNet = 0, divisionPluckerRounded = 0;
            let divisionFactoryOriginal = 0, divisionFactoryNet = 0, divisionFactoryRounded = 0;

            const divisionDeductions = {};
            const divisionFactoryDeductions = {};
            deductionTypes.forEach(type => { divisionDeductions[type] = 0; });
            factoryDeductionTypes.forEach(type => { divisionFactoryDeductions[type] = 0; });

            let j = i;
            while (j < rows.length && rows[j].division.collectionPointID === rows[i].division.collectionPointID) {

                const row = rows[j];
                result.push(row);

                divisionPluckerOriginal += row.pluckerRow?.pluckingOriginal ?? 0;
                divisionPluckerNet += row.pluckerRow?.netAmount ?? 0;
                divisionPluckerRounded += row.pluckerRow?.rounded ?? 0;

                grandPluckerOriginal += row.pluckerRow?.pluckingOriginal ?? 0;
                grandPluckerNet += row.pluckerRow?.netAmount ?? 0;
                grandPluckerRounded += row.pluckerRow?.rounded ?? 0;

                divisionFactoryOriginal += row.factoryRow?.factoryOriginal ?? 0;
                divisionFactoryNet += row.factoryRow?.factoryNet ?? 0;
                divisionFactoryRounded += row.factoryRow?.rounded ?? 0;

                grandFactoryOriginal += row.factoryRow?.factoryOriginal ?? 0;
                grandFactoryNet += row.factoryRow?.factoryNet ?? 0;
                grandFactoryRounded += row.factoryRow?.rounded ?? 0;

                deductionTypes.forEach(type => {
                    divisionDeductions[type] += row.pluckerRow?.deductions?.[type] ?? 0;
                    grandDeductions[type] += row.pluckerRow?.deductions?.[type] ?? 0;
                });

                factoryDeductionTypes.forEach(type => {
                    divisionFactoryDeductions[type] += row.factoryRow?.deductions?.[type] ?? 0;
                    grandFactoryDeductions[type] += row.factoryRow?.deductions?.[type] ?? 0;
                });

                j++;
            }

            result.push({
                rowType: "DIVISION_TOTAL",
                division: rows[i].division,
                plucker: { original: divisionPluckerOriginal, deductions: divisionDeductions, net: divisionPluckerNet, rounded: divisionPluckerRounded },
                factory: { original: divisionFactoryOriginal, deductions: divisionFactoryDeductions, net: divisionFactoryNet, rounded: divisionFactoryRounded }
            });

            i = j;
        }

        result.push({
            rowType: "GRAND_TOTAL",
            division: { collectionPointName: "Grand Total" },
            plucker: { original: grandPluckerOriginal, deductions: grandDeductions, net: grandPluckerNet, rounded: grandPluckerRounded },
            factory: { original: grandFactoryOriginal, deductions: grandFactoryDeductions, net: grandFactoryNet, rounded: grandFactoryRounded }
        });

        return result;
    }

    function createExcelData(reportRows, deductionTypes, factoryDeductionTypes) {

        const excelRows = [];

        reportRows.forEach(row => {

            if (row.rowType === "DATA") {

                const excelRow = {
                    EPF: row.pluckerRow?.registrationNumber ?? "",
                    Employee: row.pluckerRow ? `${row.pluckerRow.firstName}` : "",
                    "Collection Point": row.division?.collectionPointName ?? "",
                    Field: row.fieldGroup?.fieldName ?? "",
                    "Plucking Type": row.pluckerRow?.pluckingType ?? "",
                    "Plucker Date": row.pluckerRow ? new Date(row.pluckerRow.collectionDate).toLocaleDateString("en-GB") : "",
                    Original: row.pluckerRow?.pluckingOriginal ?? 0
                };

                deductionTypes.forEach(type => { excelRow[type] = row.pluckerRow?.deductions?.[type] ?? 0; });
                excelRow["Net Wt"] = row.pluckerRow?.netAmount ?? 0;
                excelRow["Rounded"] = row.pluckerRow?.rounded ?? 0;

                excelRow["Factory Original"] = row.factoryRow?.factoryOriginal ?? 0;
                factoryDeductionTypes.forEach(type => { excelRow["Factory " + type] = row.factoryRow?.deductions?.[type] ?? 0; });
                excelRow["Factory Net Wt"] = row.factoryRow?.factoryNet ?? 0;
                excelRow["Factory Rounded"] = row.factoryRow?.rounded ?? 0;

                excelRows.push(excelRow);

            } else if (row.rowType === "DIVISION_TOTAL") {

                const excelRow = {
                    EPF: "", Employee: "", "Collection Point": "TOTAL", Field: "", "Plucker Date": "",
                    Original: row.plucker.original
                };
                deductionTypes.forEach(type => { excelRow[type] = row.plucker.deductions[type] ?? 0; });
                excelRow["Net Wt"] = row.plucker.net;
                excelRow["Rounded"] = row.plucker.rounded;

                excelRow["Factory Original"] = row.factory.original;
                factoryDeductionTypes.forEach(type => { excelRow["Factory " + type] = row.factory.deductions[type] ?? 0; });
                excelRow["Factory Net Wt"] = row.factory.net;
                excelRow["Factory Rounded"] = row.factory.rounded;

                excelRows.push(excelRow);

            } else if (row.rowType === "GRAND_TOTAL") {

                const excelRow = {
                    EPF: "", Employee: "", "Collection Point": "GRAND TOTAL", Field: "", "Plucker Date": "",
                    Original: row.plucker.original
                };
                deductionTypes.forEach(type => { excelRow[type] = row.plucker.deductions[type] ?? 0; });
                excelRow["Net Wt"] = row.plucker.net;
                excelRow["Rounded"] = row.plucker.rounded;

                excelRow["Factory Original"] = row.factory.original;
                factoryDeductionTypes.forEach(type => { excelRow["Factory " + type] = row.factory.deductions[type] ?? 0; });
                excelRow["Factory Net Wt"] = row.factory.net;
                excelRow["Factory Rounded"] = row.factory.rounded;

                excelRows.push(excelRow);
            }
        });

        setExcelRows(excelRows);
    }

    function createExcelFile() {
        const settings = { sheetName: "Deduction Breakdown Report", fileName: "DeductionBreakdownReport", writeOptions: {} };
        const data = [...excelRows];

        data.push({});
        data.push({ EPF: "Group :" + reportSearchDetails.group });
        data.push({ EPF: "Operation Entity :" + reportSearchDetails.estate });
        data.push({ EPF: "Collection Point :" + reportSearchDetails.division });
        data.push({ EPF: "From Date :" + reportSearchDetails.fromDate });
        data.push({ EPF: "To Date :" + reportSearchDetails.toDate });

        const columns = Object.keys(excelRows[0]).map(key => ({ label: key, value: key }));
        xlsx(columns, data, settings);
    }

    async function handleSearch(e) {
        e.preventDefault();

        const errorMessages = validate(Joi.object(DeductionBreakdownReportSchemaObject), searchDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        if (new Date(searchDetails.toDate) < new Date(searchDetails.fromDate)) {
            setErrors({ ...errors, toDate: "To Date cannot be earlier than From Date" });
            return;
        }

        let result = await services.getDeductionBreakdownReport(searchDetails);

        let rows = mergeData(result.employeeWiseResult ?? [], result.deductionWiseResult ?? []);
        let factoryRows = mergeFactoryData(
            result.factoryNetResult ?? [],
            result.factoryOriginalResult ?? [],
            result.factoryDeductionResult ?? []
        );

        rows = sortRows(rows);

        const pluckerDeductionTypes = extractDeductionTypes(result.deductionWiseResult ?? []);
        const factoryOnlyDeductionTypes = extractDeductionTypes(result.factoryDeductionResult ?? []);
        const combinedDeductionTypes = [...new Set([...pluckerDeductionTypes, ...factoryOnlyDeductionTypes])];

        const deductionTypes = combinedDeductionTypes;
        const factoryDeductionTypes = combinedDeductionTypes;

        rows = populateDeductionColumns(rows, deductionTypes);
        factoryRows = populateDeductionColumns(factoryRows, factoryDeductionTypes);

        const builtFieldGroups = buildFieldGroups(rows, factoryRows);
        const flattenedRows = flattenFieldGroups(builtFieldGroups);

        if (flattenedRows.length === 0) {
            setReportRows([]);
            setDeductionTypes([]);
            setFactoryDeductionTypes([]);
            setExcelRows([]);
            setReportSearchDetails(null);

            setMessageModel({ hidden: false, type: "Warning", description: "No records found." });
            setTimeout(() => {
                setMessageModel((prev) => ({ ...prev, hidden: true }));
            }, 4000);
            return;
        }

        let reportRows = flattenedRows;
        reportRows = appendTotals(reportRows, deductionTypes, factoryDeductionTypes);
        reportRows = calculateDivisionRowSpan(reportRows);
        reportRows = calculateFieldRowSpan(reportRows);

        setDeductionTypes(deductionTypes);
        setFactoryDeductionTypes(factoryDeductionTypes);

        createExcelData(reportRows, deductionTypes, factoryDeductionTypes);

        setReportRows(reportRows);
        setReportSearchDetails(getReportSearchDetails(searchDetails));
    }

    function getReportSearchDetails(searchForm) {
        return {
            group: groups[searchForm.groupID] || "-",
            estate: estates[searchForm.estateID] || "-",
            division: searchForm.divisionID === "0" ? "All" : divisions[searchForm.divisionID] || "-",
            type: searchForm.pluckingType === "0" ? "All" : searchForm.pluckingType,
            fromDate: searchForm.fromDate,
            toDate: searchForm.toDate
        };
    }

    function clearState() {
        setReportRows([]);
        setDeductionTypes([]);
        setReportSearchDetails(null);
        setSearchDetails({
            ...searchDetails,
            divisionID: "0",
            pluckingType: "0",
            fromDate: new Date().toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0]
        });
        setErrors({});
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12" style={{ minWidth: 0 }}>
                    <div className="card">
                        <PageHeader title="Deduction Breakdown Report" isButtonEnable={permissionList.isAddEditEnabled} />
                        <div className="card-body">
                            <form onSubmit={(e) => handleSearch(e)}>
                                <div className="form-group row">

                                    <div className="col-md-4">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select fullWidth id="groupID" name="groupID" value={searchDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled} onChange={handleChange}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (<FormHelperText error>{errors["groupID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md-4">
                                        <InputLabel shrink id="estateID">Operation Entity *</InputLabel>
                                        <Select fullWidth id="estateID" name="estateID" value={searchDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled} onChange={handleChange}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(multipleEstates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText error>{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md-4">
                                        <InputLabel shrink id="divisionID">Collection Point</InputLabel>
                                        <Select fullWidth id="divisionID" name="divisionID" value={searchDetails.divisionID} onChange={handleChange}>
                                            <MenuItem value="0">--Select Collection Point--</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="fromDate">From Date *</InputLabel>
                                        <TextField fullWidth id="fromDate" name="fromDate" type="date"
                                            value={searchDetails.fromDate} onChange={handleChange}
                                            inputProps={{ max: new Date().toISOString().split('T')[0] }}
                                            InputLabelProps={{ shrink: true }} />
                                        {errors["fromDate"] && (<FormHelperText error>{errors["fromDate"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="toDate">To Date *</InputLabel>
                                        <TextField fullWidth id="toDate" name="toDate" type="date"
                                            value={searchDetails.toDate} onChange={handleChange}
                                            inputProps={{ min: searchDetails.fromDate, max: new Date().toISOString().split('T')[0] }}
                                            InputLabelProps={{ shrink: true }} />
                                        {errors["toDate"] && (<FormHelperText error>{errors["toDate"]}</FormHelperText>)}
                                    </div>

                                </div>

                                <div className="card-footer">
                                    <input type="button" className="btn btn-primary" value="Search" onClick={(e) => trackPromise(handleSearch(e))} />
                                    <input type="reset" className="btn btn-warning pull-right" value="Clear" onClick={clearState} />
                                </div>
                            </form>

                            {reportSearchDetails !== null && reportRows.length > 0 ?
                                <div className="pt-3">
                                    <TableContainer component={Paper} className="mt-3" style={{ width: "100%", overflowX: "auto" }}>
                                        <Table style={{ whiteSpace: "nowrap", minWidth: "1400px", borderColor: "white" }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell rowSpan={2}><strong>EPF</strong></TableCell>
                                                    <TableCell rowSpan={2}><strong>Employee</strong></TableCell>
                                                    <TableCell rowSpan={2}><strong>Collection Point</strong></TableCell>
                                                    <TableCell rowSpan={2}><strong>Field</strong></TableCell>
                                                    <TableCell rowSpan={2}><strong>Plucking Type</strong></TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{
                                                            background: "lightblue",
                                                            fontWeight: "bold",
                                                        }}
                                                        colSpan={deductionTypes.length + 4}>
                                                        Plucker Collection
                                                    </TableCell>
                                                    <TableCell
                                                        align="center"
                                                        style={{ background: "lightgreen", fontWeight: "bold" }}
                                                        colSpan={factoryDeductionTypes.length + 4}>
                                                        Factory Weight
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell><strong>Date</strong></TableCell>
                                                    <TableCell align="right"><strong>Original</strong></TableCell>
                                                    {deductionTypes.map(type => (<TableCell key={type} align="right"><strong>{type}</strong></TableCell>))}
                                                    <TableCell align="right"><strong>Net Wt</strong></TableCell>
                                                    <TableCell align="right"><strong>Rounded</strong></TableCell>
                                                    <TableCell align="right"><strong>Original</strong></TableCell>
                                                    {factoryDeductionTypes.map(type => (<TableCell key={type} align="right"><strong>{type}</strong></TableCell>))}
                                                    <TableCell align="right"><strong>Net Wt</strong></TableCell>
                                                    <TableCell align="right"><strong>Rounded</strong></TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {reportRows.map((row, index) => {

                                                    if (row.rowType === "DATA") {
                                                        const factory = row.factoryRow;

                                                        return (
                                                            <TableRow key={index}>
                                                                <TableCell>{row.pluckerRow?.registrationNumber}</TableCell>
                                                                <TableCell>{row.pluckerRow ? `${row.pluckerRow.firstName}` : ""}</TableCell>

                                                                {row.isFirstDivisionRow && (
                                                                    <TableCell rowSpan={row.divisionRowSpan} align="center" style={{ verticalAlign: "middle" }}>
                                                                        {row.division.collectionPointName}
                                                                    </TableCell>
                                                                )}
                                                                {row.isFirstFieldRow && (
                                                                    <TableCell rowSpan={row.fieldRowSpan} align="center" style={{ verticalAlign: "middle" }}>
                                                                        {row.fieldGroup.fieldName}
                                                                    </TableCell>
                                                                )}

                                                                <TableCell>{row.pluckerRow?.pluckingType ?? ""}</TableCell>

                                                                <TableCell>
                                                                    {row.pluckerRow ? new Date(row.pluckerRow.collectionDate).toLocaleDateString("en-GB") : ""}
                                                                </TableCell>
                                                                <TableCell align="right">{row.pluckerRow?.pluckingOriginal}</TableCell>
                                                                {deductionTypes.map(type => (
                                                                    <TableCell key={type} align="right">{row.pluckerRow?.deductions?.[type] ?? 0}</TableCell>
                                                                ))}
                                                                <TableCell align="right">{row.pluckerRow?.netAmount ?? 0}</TableCell>
                                                                <TableCell align="right">{row.pluckerRow?.rounded ?? 0}</TableCell>

                                                                {factory && (
                                                                    <>
                                                                        <TableCell rowSpan={row.dateRowSpan} align="right" style={{ verticalAlign: "top" }}>
                                                                            {factory.factoryOriginal ?? 0}
                                                                        </TableCell>
                                                                        {factoryDeductionTypes.map(type => (
                                                                            <TableCell key={type} rowSpan={row.dateRowSpan} align="right" style={{ verticalAlign: "top" }}>
                                                                                {factory.deductions?.[type] ?? 0}
                                                                            </TableCell>
                                                                        ))}
                                                                        <TableCell rowSpan={row.dateRowSpan} align="right" style={{ verticalAlign: "top" }}>
                                                                            {factory.factoryNet ?? 0}
                                                                        </TableCell>
                                                                        <TableCell rowSpan={row.dateRowSpan} align="right" style={{ verticalAlign: "top" }}>
                                                                            {factory.rounded ?? 0}
                                                                        </TableCell>
                                                                    </>
                                                                )}
                                                            </TableRow>
                                                        );
                                                    }
                                                    if (row.rowType === "DIVISION_TOTAL") {
                                                        return (
                                                            <TableRow key={index} style={{ backgroundColor: "#f5f5f5" }}>
                                                                <TableCell colSpan={6} align="center"><strong>TOTAL</strong></TableCell>
                                                                <TableCell align="right"><strong>{row.plucker.original.toFixed(2)}</strong></TableCell>
                                                                {deductionTypes.map(type => (
                                                                    <TableCell key={type} align="right"><strong>{(row.plucker.deductions[type] ?? 0).toFixed(2)}</strong></TableCell>
                                                                ))}
                                                                <TableCell align="right"><strong>{row.plucker.net.toFixed(2)}</strong></TableCell>
                                                                <TableCell align="right"><strong>{row.plucker.rounded}</strong></TableCell>

                                                                <TableCell align="right"><strong>{row.factory.original.toFixed(2)}</strong></TableCell>
                                                                {factoryDeductionTypes.map(type => (
                                                                    <TableCell key={type} align="right"><strong>{(row.factory.deductions[type] ?? 0).toFixed(2)}</strong></TableCell>
                                                                ))}
                                                                <TableCell align="right"><strong>{row.factory.net.toFixed(2)}</strong></TableCell>
                                                                <TableCell align="right"><strong>{row.factory.rounded}</strong></TableCell>
                                                            </TableRow>
                                                        );
                                                    }
                                                    if (row.rowType === "GRAND_TOTAL") {
                                                        return (
                                                            <TableRow key={index} style={{ backgroundColor: "#e0e0e0" }}>
                                                                <TableCell colSpan={6} align="center"><strong>GRAND TOTAL</strong></TableCell>
                                                                <TableCell align="right"><strong>{row.plucker.original.toFixed(2)}</strong></TableCell>
                                                                {deductionTypes.map(type => (
                                                                    <TableCell key={type} align="right"><strong>{(row.plucker.deductions[type] ?? 0).toFixed(2)}</strong></TableCell>
                                                                ))}
                                                                <TableCell align="right"><strong>{row.plucker.net.toFixed(2)}</strong></TableCell>
                                                                <TableCell align="right"><strong>{row.plucker.rounded}</strong></TableCell>

                                                                <TableCell align="right"><strong>{row.factory.original.toFixed(2)}</strong></TableCell>
                                                                {factoryDeductionTypes.map(type => (
                                                                    <TableCell key={type} align="right"><strong>{(row.factory.deductions[type] ?? 0).toFixed(2)}</strong></TableCell>
                                                                ))}
                                                                <TableCell align="right"><strong>{row.factory.net.toFixed(2)}</strong></TableCell>
                                                                <TableCell align="right"><strong>{row.factory.rounded}</strong></TableCell>
                                                            </TableRow>
                                                        );
                                                    }

                                                    return null;
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <div className="mt-3 text-right">
                                        <button type="button" className="btn btn-primary pull-right ml-2 mr-2" onClick={createExcelFile}>Excel</button>
                                        <ReactToPrint
                                            documentTitle={"Deduction Breakdown Report"}
                                            trigger={() => <input type="button" className="btn btn-primary pull-right" value="PDF" />}
                                            content={() => componentRef.current}
                                        />
                                        <div style={{ display: "none" }}>
                                            <CreatePdf
                                                ref={componentRef}
                                                reportRows={reportRows}
                                                searchData={reportSearchDetails}
                                                deductionTypes={deductionTypes}
                                                factoryDeductionTypes={factoryDeductionTypes}
                                            />
                                        </div>
                                    </div>
                                </div>
                                : null}
                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.description}
                clicked={modalDismissHandler} />
        </Fragment>
    );
}